import { jsx } from 'react/jsx-runtime';

const SpanishFlag = props => {
  return /*#__PURE__*/jsx("img", {
    ...props,
    width: "20",
    height: "20",
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAACCElEQVR4AWIgF6wSBVRjDzB3BEEcwLe2jbudz3pzaWO7tt3YelGtmLWNsMbtXW3Fd7FV2wgfpprqWfP9k7N+591t6e5akdHGwq0G8LoHTpDs4j+64Ps8PO1ZLfNODWvsp8qRuFJtjR1ZyJisOkZrZ4U7dGjXUsDaeBZOMRpfZw1K0Rlw3hL0OkDnouB83TzSaOdx/qjUUF/juMJwtjMpf0SWUBvX5HdLdcuqUuO4w4NHBg3qljXQ6MiK8uEYmR3OciaXHcfdurQ4b3gjVgjGnYVT/otL0tu6Gl9VGkhv97E+1b3+AbqAUyuMS32r4ymunpir+Ghvw8xHexvjkrqHexv5Kn6+U3f/8536uKyuLlCUF9cHdJcF4+7rfQD16W7taKnAL3dqo+rz7frtQoHUnaHn75JU4KfbdTcIGEgFkk3JhHHXKoChYGCo6EEU/pLUnxH9mfl4q2au6A/1+3vD+4r+1VGEviih+plPt2uXigPerufi1sMNw7s83NPwTkpZkCxvD0Jv9Xs8wGVii/wUX9V2Si54JwD37jqM6K3+l3O6eVylgT7g1AyNRbhayK1NHQN4qNw4OqbKNtTIyMjy4Pi5yyF0yYXc1tRx7ZbFJXq73/ELUWColk9nWiToO9oX39Ii5vIPqAEM83jOQoaVIeehEQw4UQ/wTLK78R3AGJpHy2gdWlflmQQu0zFBKH1VIwAAAABJRU5ErkJggg==",
    alt: "Spansk"
  });
};

export { SpanishFlag };
//# sourceMappingURL=Spanish.js.map
